import React from "react";
import { 
  FaPhoneAlt, 
  FaEnvelope, 
  FaMapMarkerAlt, 
  FaWhatsapp,
  FaClock
} from "react-icons/fa";
import "../styles/ContactBar.css";

const ContactBar = () => {
  const contactItems = [
    {
      id: 1,
      icon: <FaPhoneAlt />,
      title: "Call Us 24/7",
      info: "+91 7428203483",
      link: "tel:+917428203483",
      subtext: "Available 24 hours, 7 days a week",
      color: "#3b82f6"
    },
    {
      id: 2,
      icon: <FaWhatsapp />,
      title: "WhatsApp Chat",
      info: "+91 7428203483",
      link: "https://wa.me/917428203483",
      subtext: "Instant response within minutes",
      color: "#25D366"
    },
    {
      id: 3,
      icon: <FaEnvelope />,
      title: "Email Support",
      info: "indiandetective23@gmail.com",
      link: "mailto:indiandetective23@gmail.com",
      subtext: "We'll respond within 24 hours",
      color: "#ef4444"
    },
    {
      id: 4,
      icon: <FaMapMarkerAlt />,
      title: "Visit Our Office",
      info: "Rohini, North West Delhi",
      link: "https://maps.google.com/?q=Rohini+Delhi",
      subtext: "H.NO-118, Rohini, Delhi 110042",
      color: "#f59e0b"
    }
  ];

  return (
    <div className="contact-bar-no-bg">
      <div className="contact-no-bg-container">
        {/* Header Section */}
        <div className="contact-no-bg-header">
          <FaClock className="header-icon" />
          <div>
            <h3>Get in Touch With Us</h3>
            <p>We're here to help you 24/7. Choose your preferred way to connect.</p>
          </div>
        </div>

        {/* Contact Cards Grid */}
        <div className="contact-no-bg-grid">
          {contactItems.map((item) => (
            <a
              key={item.id}
              href={item.link}
              target={item.id === 4 ? "_blank" : "_self"}
              rel="noopener noreferrer"
              className="contact-no-bg-card"
            >
              <div className="card-icon" style={{ color: item.color }}>
                {item.icon}
              </div>
              <div className="card-content">
                <h4 style={{ color: item.color }}>{item.title}</h4>
                <p className="card-info">{item.info}</p>
                <span className="card-subtext">{item.subtext}</span>
              </div>
            </a>
          ))}
        </div>

        {/* Bottom Stats Bar */}
        <div className="contact-no-bg-stats">
          <div className="stat-item">
            <span className="stat-number">30 min</span>
            <span className="stat-label">Average Response</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <span className="stat-number">24/7</span>
            <span className="stat-label">Emergency Support</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <span className="stat-number">100%</span>
            <span className="stat-label">Confidential</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactBar;